// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:960px){.tutorials__videos[data-v-1bfa1db0]{display:grid;grid-template-columns:repeat(3,1fr);grid-gap:1.2rem;gap:1.2rem}}.tutorials__title[data-v-1bfa1db0]{margin:2.625rem 0}@media only screen and (min-width:960px){.tutorials__title[data-v-1bfa1db0]{margin:5rem 0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
